import { useCallback, useLayoutEffect, useRef } from "react";

export const useSound = (url: string, type: string) => {
  const ref = useRef<any>();
  useLayoutEffect(() => {
    ref.current = document.createElement("audio");
    const source = document.createElement("source");
    source.src = url;
    source.type = type;
    ref.current.appendChild(source);
    document.body.appendChild(ref.current);

    return () => {
      if (ref.current) {
        ref.current.remove();
        ref.current = null;
      }
    };
  }, [url, type]);

  const play = useCallback(async () => {
    ref.current?.play();
  }, []);

  return {
    play,
  };
};
